// ── Spanish translations for built-in stimulus content ──────────────────────
// Flat lookup: exact English string (as written in src/data/stimuli.js and
// src/data/sequencing.js) -> Spanish translation. Looked up via
// translateContent() in ./content.js. Firestore-authored content (custom
// decks, admin-generated sequencing activities) isn't covered here — it's
// author-entered per user/admin and has no fixed English source string to
// key off of.
export const CONTENT_ES = {
  // ── Flashcard deck (category) names ──
  'Food': 'Comida',
  'Animals': 'Animales',
  'Colors': 'Colores',
  'Actions': 'Acciones',
  'Emotions': 'Emociones',
  'Shapes': 'Formas',
  'School': 'Escuela',
  'Vehicles': 'Vehículos',
  'Body Parts': 'Partes del Cuerpo',
  'Verbs': 'Verbos',
  'Clothing': 'Ropa',
  'Household': 'Hogar',
  'Sports': 'Deportes',
  'Community Helpers': 'Ayudantes de la Comunidad',
  'Toys': 'Juguetes',
  'Hygiene': 'Higiene',
  'Nature': 'Naturaleza',
  'Weather': 'Clima',

  // ── Flashcard item labels ──
  'Airplane': 'Avión',
  'Ambulance': 'Ambulancia',
  'Angry': 'Enojado',
  'Apple': 'Manzana',
  'Backpack': 'Mochila',
  'Ball': 'Pelota',
  'Banana': 'Plátano',
  'Bandage': 'Curita',
  'Baseball': 'Béisbol',
  'Basketball': 'Baloncesto',
  'Bathtub': 'Bañera',
  'Bear': 'Oso',
  'Bed': 'Cama',
  'Bicycle': 'Bicicleta',
  'Bird': 'Pájaro',
  'Black': 'Negro',
  'Blocks': 'Bloques',
  'Blue': 'Azul',
  'Blueberry': 'Arándano',
  'Boat': 'Barco',
  'Book': 'Libro',
  'Boots': 'Botas',
  'Bowling': 'Boliche',
  'Bread': 'Pan',
  'Brown': 'Marrón',
  'Bubbles': 'Burbujas',
  'Burger': 'Hamburguesa',
  'Bus': 'Autobús',
  'Cake': 'Pastel',
  'Car': 'Carro',
  'Cat': 'Gato',
  'Chair': 'Silla',
  'Chalkboard': 'Pizarrón',
  'Cheese': 'Queso',
  'Chef': 'Cocinero',
  'Cherry': 'Cereza',
  'Circle': 'Círculo',
  'Clapping': 'Aplaudiendo',
  'Cloud': 'Nube',
  'Cloudy': 'Nublado',
  'Coat': 'Abrigo',
  'Comb': 'Peine',
  'Confused': 'Confundido',
  'Construction Worker': 'Obrero de Construcción',
  'Cookie': 'Galleta',
  'Couch': 'Sofá',
  'Cow': 'Vaca',
  'Crayon': 'Crayón',
  'Cup': 'Taza',
  'Dancing': 'Bailando',
  'Dentist': 'Dentista',
  'Diamond': 'Diamante',
  'Doctor': 'Doctor',
  'Dog': 'Perro',
  'Doll': 'Muñeca',
  'Dolphin': 'Delfín',
  'Door': 'Puerta',
  'Drawing': 'Dibujando',
  'Dress': 'Vestido',
  'Drum': 'Tambor',
  'Duck': 'Pato',
  'Ears': 'Orejas',
  'Eat': 'Comer',
  'Eating': 'Comiendo',
  'Elephant': 'Elefante',
  'Eraser': 'Borrador',
  'Excited': 'Emocionado',
  'Eyes': 'Ojos',
  'Farmer': 'Granjero',
  'Feet': 'Pies',
  'Firefighter': 'Bombero',
  'Fish': 'Pez',
  'Flower': 'Flor',
  'Foggy': 'Neblinoso',
  'Football': 'Fútbol Americano',
  'Fork': 'Tenedor',
  'Frog': 'Rana',
  'Frost': 'Escarcha',
  'Giraffe': 'Jirafa',
  'Glue': 'Pegamento',
  'Golf': 'Golf',
  'Grapes': 'Uvas',
  'Grass': 'Pasto',
  'Gray': 'Gris',
  'Green': 'Verde',
  'Gymnastics': 'Gimnasia',
  'Hail': 'Granizo',
  'Hands': 'Manos',
  'Happy': 'Feliz',
  'Hat': 'Sombrero',
  'Heart': 'Corazón',
  'Helicopter': 'Helicóptero',
  'Hexagon': 'Hexágono',
  'Hockey': 'Hockey',
  'Horse': 'Caballo',
  'Hot Dog': 'Perro Caliente',
  'Ice Cream': 'Helado',
  'Jacket': 'Chaqueta',
  'Jump': 'Saltar',
  'Jump Rope': 'Cuerda para Saltar',
  'Jumping': 'Saltando',
  'Kite': 'Cometa',
  'Lamp': 'Lámpara',
  'Librarian': 'Bibliotecario',
  'Lightning': 'Relámpago',
  'Lion': 'León',
  'Mango': 'Mango',
  'Marker': 'Marcador',
  'Monkey': 'Mono',
  'Moon': 'Luna',
  'Motorcycle': 'Motocicleta',
  'Mountain': 'Montaña',
  'Mouth': 'Boca',
  'Nose': 'Nariz',
  'Nurse': 'Enfermero',
  'Ocean': 'Océano',
  'Orange': 'Naranja',
  'Oval': 'Óvalo',
  'Pants': 'Pantalones',
  'Pasta': 'Pasta',
  'Peach': 'Durazno',
  'Pear': 'Pera',
  'Pencil': 'Lápiz',
  'Penguin': 'Pingüino',
  'Pentagon': 'Pentágono',
  'Pig': 'Cerdo',
  'Pineapple': 'Piña',
  'Pink': 'Rosado',
  'Pizza': 'Pizza',
  'Plate': 'Plato',
  'Police Officer': 'Policía',
  'Pork': 'Carne de Cerdo',
  'Proud': 'Orgulloso',
  'Purple': 'Morado',
  'Puzzle': 'Rompecabezas',
  'Rabbit': 'Conejo',
  'Rain': 'Lluvia',
  'Rainbow': 'Arcoíris',
  'Rainy': 'Lluvioso',
  'Reading': 'Leyendo',
  'Rectangle': 'Rectángulo',
  'Red': 'Rojo',
  'Ruler': 'Regla',
  'Run': 'Correr',
  'Running': 'Corriendo',
  'Sad': 'Triste',
  'Salad': 'Ensalada',
  'Sandwich': 'Sándwich',
  'Scared': 'Asustado',
  'Scissors': 'Tijeras',
  'Shampoo': 'Champú',
  'Sheep': 'Oveja',
  'Shirt': 'Camisa',
  'Shoes': 'Zapatos',
  'Shorts': 'Pantalones Cortos',
  'Silly': 'Tonto',
  'Sit': 'Sentarse',
  'Sleep': 'Dormir',
  'Sleeping': 'Durmiendo',
  'Snowy': 'Nevado',
  'Soap': 'Jabón',
  'Soccer': 'Fútbol',
  'Socks': 'Calcetines',
  'Soup': 'Sopa',
  'Spoon': 'Cuchara',
  'Square': 'Cuadrado',
  'Star': 'Estrella',
  'Stormy': 'Tormentoso',
  'Strawberry': 'Fresa',
  'Sun': 'Sol',
  'Sunny': 'Soleado',
  'Surprised': 'Sorprendido',
  'Sushi': 'Sushi',
  'Swimming': 'Nadando',
  'Table': 'Mesa',
  'Taco': 'Taco',
  'Teacher': 'Maestro',
  'Teddy Bear': 'Oso de Peluche',
  'Tennis': 'Tenis',
  'Tiger': 'Tigre',
  'Tired': 'Cansado',
  'Tissue': 'Pañuelo',
  'Toilet': 'Inodoro',
  'Toothbrush': 'Cepillo de Dientes',
  'Toothpaste': 'Pasta de Dientes',
  'Towel': 'Toalla',
  'Toy Train': 'Tren de Juguete',
  'Train': 'Tren',
  'Tree': 'Árbol',
  'Triangle': 'Triángulo',
  'Truck': 'Camión',
  'Turtle': 'Tortuga',
  'Volleyball': 'Voleibol',
  'Walk': 'Caminar',
  'Watermelon': 'Sandía',
  'Waving': 'Saludando',
  'White': 'Blanco',
  'Windy': 'Ventoso',
  'Yellow': 'Amarillo',

  // ── Sequencing categories ──
  'Academic': 'Académico',
  'Cooking': 'Cocina',
  'Daily Living': 'Vida Diaria',
  'Safety': 'Seguridad',
  'Social Skills': 'Habilidades Sociales',

  // ── Sequencing difficulty labels ──
  'Beginner': 'Principiante',
  'Intermediate': 'Intermedio',
  'Advanced': 'Avanzado',

  // ── Sequencing deck titles ──
  'Brushing Teeth': 'Cepillarse los Dientes',
  'Cleaning Up Toys': 'Recoger los Juguetes',
  'Combing Your Hair': 'Peinarse el Cabello',
  'Cooking Food in the Microwave': 'Cocinar en el Microondas',
  'Crossing the Street Safely': 'Cruzar la Calle con Seguridad',
  'Feeding a Pet': 'Alimentar a una Mascota',
  'Getting Dressed': 'Vestirse',
  'Getting Ready for School': 'Alistarse para la Escuela',
  'Going to the Bathroom': 'Ir al Baño',
  'Making a Sandwich': 'Hacer un Sándwich',
  'Packing Up to Go Home': 'Empacar para Ir a Casa',
  'Putting on a Jacket': 'Ponerse una Chaqueta',
  'Taking a Shower': 'Ducharse',
  'Tying Your Shoes': 'Amarrarse los Zapatos',
  'Waiting in Line': 'Esperar en la Fila',
  'Washing Dishes': 'Lavar los Platos',
  'Washing Hands': 'Lavarse las Manos',
  'Watering a Plant': 'Regar una Planta',

  // ── Sequencing deck descriptions ──
  'Put the dish-washing steps in the correct order.': 'Pon los pasos de lavar los platos en el orden correcto.',
  'Put the end-of-day packing-up steps in the correct order.': 'Pon los pasos para empacar al final del día en el orden correcto.',
  'Put the hair-combing steps in the correct order.': 'Pon los pasos para peinarse en el orden correcto.',
  'Put the jacket steps in the correct order.': 'Pon los pasos para ponerse la chaqueta en el orden correcto.',
  'Put the line-waiting steps in the correct order.': 'Pon los pasos para esperar en la fila en el orden correcto.',
  'Put the microwave-cooking steps in the correct order.': 'Pon los pasos para cocinar en el microondas en el orden correcto.',
  'Put the morning dressing steps in the correct order.': 'Pon los pasos para vestirse por la mañana en el orden correcto.',
  'Put the morning routine steps in the correct order.': 'Pon los pasos de la rutina matutina en el orden correcto.',
  'Put the pet-feeding steps in the correct order.': 'Pon los pasos para alimentar a la mascota en el orden correcto.',
  'Put the plant watering steps in the correct order.': 'Pon los pasos para regar la planta en el orden correcto.',
  'Put the shoe-tying steps in the correct order.': 'Pon los pasos para amarrarse los zapatos en el orden correcto.',
  'Put the shower steps in the correct order.': 'Pon los pasos para ducharse en el orden correcto.',
  'Put the steps for brushing teeth in the correct order.': 'Pon los pasos para cepillarse los dientes en el orden correcto.',
  'Put the steps for making a sandwich in the correct order.': 'Pon los pasos para hacer un sándwich en el orden correcto.',
  'Put the steps for washing hands in the correct order.': 'Pon los pasos para lavarse las manos en el orden correcto.',
  'Put the street-crossing steps in the correct order.': 'Pon los pasos para cruzar la calle en el orden correcto.',
  'Put the toileting steps in the correct order.': 'Pon los pasos para ir al baño en el orden correcto.',
  'Put the toy clean-up steps in the correct order.': 'Pon los pasos para recoger los juguetes en el orden correcto.',

  // ── Sequencing step labels ──
  'Add soap to the sponge': 'Ponle jabón a la esponja',
  'Add toothpaste to brush': 'Ponle pasta de dientes al cepillo',
  'Add your fillings': 'Agrega tu relleno',
  'Brush from the roots to the ends': 'Cepilla desde la raíz hasta las puntas',
  'Brush from the top of your head down': 'Cepilla desde arriba de la cabeza hacia abajo',
  'Brush your hair': 'Cepíllate el cabello',
  'Brush your teeth': 'Cepíllate los dientes',
  'Carry it to the plant': 'Llévala a la planta',
  'Check for the walk signal or crosswalk sign': 'Revisa la señal de cruce peatonal',
  'Check the food is microwave-safe': 'Verifica que la comida sea apta para microondas',
  'Check the front, sides, and back': 'Revisa el frente, los lados y la parte de atrás',
  'Check the water bowl': 'Revisa el tazón de agua',
  'Clean up your area': 'Limpia tu área',
  'Close the door': 'Cierra la puerta',
  'Cross the laces to make an X': 'Cruza las agujetas para hacer una X',
  'Cross the loops and pull them into a knot': 'Cruza los lazos y jálalos para hacer un nudo',
  'Cross the right lace over the left': 'Cruza la agujeta derecha sobre la izquierda',
  'Cut the sandwich in half': 'Corta el sándwich por la mitad',
  'Dry off with a towel and get dressed': 'Sécate con una toalla y vístete',
  'Dry the dish': 'Seca el plato',
  'Dry with a towel': 'Seca con una toalla',
  'Dry your hands': 'Sécate las manos',
  'Eat breakfast': 'Desayuna',
  'Fill it with water': 'Llénala de agua',
  'Find the end of the line': 'Busca el final de la fila',
  'Find your jacket': 'Busca tu chaqueta',
  'Find your jacket on the hook': 'Busca tu chaqueta en el gancho',
  'Fix any tangles': 'Arregla los enredos',
  'Flush the toilet': 'Jala la cadena del inodoro',
  'Get a watering can': 'Consigue una regadera',
  'Get dressed': 'Vístete',
  "Get the pet's food": 'Consigue la comida de la mascota',
  "Get the pet's food bowl": 'Consigue el tazón de comida de la mascota',
  'Get two slices of bread': 'Consigue dos rebanadas de pan',
  'Get undressed': 'Desvístete',
  'Get undressed and get in the shower': 'Desvístete y entra a la ducha',
  'Get your comb or brush': 'Consigue tu peine o cepillo',
  'Get your toothbrush': 'Consigue tu cepillo de dientes',
  'Give the bowl to your pet': 'Dale el tazón a tu mascota',
  'Give your pet fresh water': 'Dale agua fresca a tu mascota',
  'Go to your dresser or closet': 'Ve a tu cómoda o clóset',
  'Grab your backpack': 'Toma tu mochila',
  'Hold a lace in each hand': 'Sostén una agujeta en cada mano',
  "Hold an adult's hand": 'Toma la mano de un adulto',
  'Hold one lace in each hand': 'Sostén una agujeta en cada mano',
  'Hold the jacket open': 'Sostén la chaqueta abierta',
  'Hold the jacket open in front of you': 'Sostén la chaqueta abierta frente a ti',
  'Keep looking for cars while you cross': 'Sigue mirando si vienen carros mientras cruzas',
  'Keep your hands and feet to yourself': 'Mantén tus manos y pies quietos',
  'Keep your hands to yourself': 'Mantén tus manos quietas',
  'Line up': 'Fórmate en fila',
  'Line up quietly': 'Fórmate en fila en silencio',
  'Line up the zipper at the bottom': 'Alinea el cierre en la parte de abajo',
  'Look around for toys on the floor': 'Busca juguetes en el piso',
  'Look around the room for toys': 'Busca juguetes por el cuarto',
  'Look both ways': 'Mira hacia ambos lados',
  'Look in the mirror': 'Mírate en el espejo',
  "Look in the mirror — you're ready!": 'Mírate en el espejo — ¡ya estás listo!',
  'Look left, then right, then left again': 'Mira a la izquierda, luego a la derecha, y otra vez a la izquierda',
  'Make a loop ("bunny ear") with one lace': 'Haz un lazo ("oreja de conejo") con una agujeta',
  'Make a loop with each lace': 'Haz un lazo con cada agujeta',
  'Make sure all cars have stopped': 'Asegúrate de que todos los carros se detuvieron',
  'Make two loops ("bunny ears")': 'Haz dos lazos ("orejas de conejo")',
  'Measure the correct amount of food': 'Mide la cantidad correcta de comida',
  'Measure the right amount of food': 'Mide la cantidad correcta de comida',
  'Move forward as the line moves': 'Avanza conforme se mueve la fila',
  'Open the door carefully': 'Abre la puerta con cuidado',
  'Pack your lunch': 'Empaca tu almuerzo',
  'Pick out your clothes': 'Elige tu ropa',
  'Pick up the toys': 'Recoge los juguetes',
  'Pick up toys one at a time': 'Recoge los juguetes de uno en uno',
  'Pour food into the bowl': 'Vierte la comida en el tazón',
  'Pour the food into the bowl': 'Vierte la comida en el tazón',
  'Pour water on the soil': 'Vierte agua sobre la tierra',
  'Press start': 'Presiona iniciar',
  'Pull both laces tight': 'Jala ambas agujetas para apretarlas',
  'Pull both laces tight to make a base knot': 'Jala ambas agujetas para hacer un nudo base',
  'Pull both loops tight to finish the knot': 'Jala ambos lazos para terminar el nudo',
  'Pull down your pants': 'Bájate los pantalones',
  'Pull one lace under and through': 'Pasa una agujeta por debajo y hacia afuera',
  'Pull one lace under and through the X': 'Pasa una agujeta por debajo y a través de la X',
  'Pull the jacket onto your shoulders': 'Sube la chaqueta hasta los hombros',
  'Pull up your pants': 'Súbete los pantalones',
  'Push in any chairs': 'Acomoda las sillas',
  'Push in your chair': 'Acomoda tu silla',
  'Push it through to make a second loop': 'Pásala para hacer un segundo lazo',
  'Put blocks in the block bin': 'Pon los bloques en su contenedor',
  'Put blocks in the toy bin': 'Pon los bloques en el contenedor de juguetes',
  'Put books back on the shelf': 'Pon los libros de vuelta en el estante',
  'Put books on the shelf': 'Pon los libros en el estante',
  'Put both bowls down for your pet': 'Coloca ambos tazones para tu mascota',
  'Put food in the bowl': 'Pon comida en el tazón',
  'Put food on a microwave-safe plate': 'Pon la comida en un plato apto para microondas',
  'Put food on a plate': 'Pon la comida en un plato',
  'Put homework in your folder': 'Pon la tarea en tu carpeta',
  'Put it away': 'Guárdalo',
  'Put it in the cabinet': 'Ponlo en el gabinete',
  'Put it in the drying rack': 'Ponlo en el escurridor',
  'Put it on a plate': 'Ponlo en un plato',
  'Put on your clothes': 'Ponte la ropa',
  'Put on your shoes': 'Ponte los zapatos',
  'Put one arm all the way into a sleeve': 'Mete un brazo completamente en una manga',
  'Put one arm in a sleeve': 'Mete un brazo en una manga',
  'Put shampoo in your hair and scrub': 'Ponte champú en el cabello y frota',
  'Put soap on a washcloth and wash your body': 'Pon jabón en una toallita y lava tu cuerpo',
  'Put soap on hands': 'Ponte jabón en las manos',
  'Put stuffed animals in the toy chest': 'Pon los peluches en el baúl de juguetes',
  'Put the bin away': 'Guarda el contenedor',
  'Put the bin on the shelf': 'Pon el contenedor en el estante',
  'Put the bowl down for your pet': 'Coloca el tazón para tu mascota',
  'Put the comb away': 'Guarda el peine',
  'Put the comb or brush away': 'Guarda el peine o cepillo',
  'Put the other arm in a sleeve': 'Mete el otro brazo en una manga',
  'Put the other arm into the other sleeve': 'Mete el otro brazo en la otra manga',
  'Put the plate in the microwave': 'Pon el plato en el microondas',
  'Put the top slice on': 'Pon la rebanada de arriba',
  'Put the watering can away': 'Guarda la regadera',
  'Put things in your backpack': 'Pon tus cosas en la mochila',
  'Put toothbrush away': 'Guarda el cepillo de dientes',
  'Put toys in the bin': 'Pon los juguetes en el contenedor',
  'Put your arms in the sleeves': 'Mete los brazos en las mangas',
  'Put your folder in your backpack': 'Pon tu carpeta en la mochila',
  "Refill the water if it's low": 'Rellena el agua si está baja',
  'Rinse off': 'Enjuágate',
  'Rinse off all the soap': 'Enjuaga todo el jabón',
  'Rinse off the soap': 'Enjuaga el jabón',
  'Rinse the dish': 'Enjuaga el plato',
  'Rinse the shampoo out': 'Enjuaga el champú',
  'Rinse with water': 'Enjuaga con agua',
  'Say "thank you" when you\'re done': 'Di "gracias" cuando termines',
  'Scrape food into the trash': 'Raspa la comida a la basura',
  'Scrape off the food': 'Raspa la comida',
  'Scrub for 20 seconds': 'Frota durante 20 segundos',
  'Scrub the dish': 'Talla el plato',
  'Set the timer': 'Pon el temporizador',
  'Sit on the toilet': 'Siéntate en el inodoro',
  'Sort toys by type': 'Clasifica los juguetes por tipo',
  'Sort toys into the correct bins': 'Clasifica los juguetes en los contenedores correctos',
  'Spit into the sink': 'Escupe en el lavabo',
  'Spread butter or mayo': 'Unta mantequilla o mayonesa',
  'Stand behind the last person': 'Párate detrás de la última persona',
  'Stand behind the last person with space between you': 'Párate detrás de la última persona dejando espacio',
  'Stand in front of the mirror': 'Párate frente al espejo',
  'Start brushing at the ends of your hair': 'Empieza a cepillar desde las puntas del cabello',
  'Step up onto the curb on the other side': 'Sube a la acera del otro lado',
  'Stop at the curb': 'Detente en la acera',
  'Stop at the curb before stepping into the street': 'Detente en la acera antes de pisar la calle',
  'Take the plate out': 'Saca el plato',
  'Take the plate out carefully': 'Saca el plato con cuidado',
  "Take the plate out with a towel — it's hot!": 'Saca el plato con una toalla — ¡está caliente!',
  "Take your turn when it's time": 'Toma tu turno cuando sea el momento',
  'Throw away your trash': 'Tira tu basura',
  'Tie the loops in a knot': 'Amarra los lazos en un nudo',
  'Turn off the lights when done': 'Apaga las luces cuando termines',
  'Turn off the water': 'Cierra el agua',
  'Turn off the water and dry off': 'Cierra el agua y sécate',
  'Turn off the water and dry off with a towel': 'Cierra el agua y sécate con una toalla',
  'Turn on the water': 'Abre el agua',
  'Turn on the water and check the temperature': 'Abre el agua y revisa la temperatura',
  'Use the bathroom': 'Usa el baño',
  'Wait for cars to stop': 'Espera a que los carros se detengan',
  'Wait for the beep': 'Espera el pitido',
  'Wait for your name': 'Espera a que digan tu nombre',
  'Wait for your turn': 'Espera tu turno',
  'Wait quietly for your turn': 'Espera tu turno en silencio',
  'Wait quietly without pushing': 'Espera en silencio sin empujar',
  'Wake up': 'Despiértate',
  'Wake up and get out of bed': 'Despiértate y levántate de la cama',
  "Walk (don't run) across the street": 'Camina (no corras) al cruzar la calle',
  'Walk across the street': 'Cruza la calle caminando',
  "Walk across when it's clear": 'Camina cuando esté despejado',
  'Walk to the bathroom': 'Camina al baño',
  'Walk to the door': 'Camina a la puerta',
  'Wash with soap': 'Lava con jabón',
  'Wash with soap and a sponge': 'Lava con jabón y una esponja',
  'Wash your body': 'Lava tu cuerpo',
  'Wash your body with soap': 'Lava tu cuerpo con jabón',
  'Wash your face': 'Lávate la cara',
  'Wash your hair with shampoo': 'Lávate el cabello con champú',
  'Wash your hands': 'Lávate las manos',
  'Wash your hands again after feeding': 'Lávate las manos otra vez después de alimentarla',
  'Watch for your turn': 'Espera atento a tu turno',
  'Wet your hair and body': 'Moja tu cabello y cuerpo',
  'Wet your hands': 'Mójate las manos',
  'Wipe': 'Límpiate',
  'Wipe the counter': 'Limpia la mesada',
  'Work out any tangles gently': 'Deshaz los enredos con cuidado',
  'Wrap the other lace around the loop': 'Envuelve la otra agujeta alrededor del lazo',
  'Zip it up': 'Cierra el cierre',
  'Zip the jacket up to the top': 'Sube el cierre de la chaqueta hasta arriba',
  'Zip up the jacket': 'Cierra el cierre de la chaqueta',
  'Zip up your backpack': 'Cierra tu mochila',
};
